import React from 'react';

const TableType = {
    FeatureFlag: 'featureFlag',
    Configuration: 'configuration'
  }

// This is the table constant/settings which needed to render table elements
 const TableConstants = (flags) => {
    let cols = [];
    for(var flag in flags){
        return Object.keys(flags[flag]).map(k => 
            ({
                title: k, 
                render: rowData=> { return <span>{rowData[k]}</span>;}
            })
            );
    }
    return cols;
};

export { TableConstants, TableType}